module.exports = __webpack_public_path__ + "media/images/athletes/1582-70d3c766baedb6231c2a87ef2d4a2afc.png";